import React, { Component } from "react";
import { withRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation, withNamespaces } from 'react-i18next';

// Containers
import HomeContainer from "./Home/index";
import LoginContainer from "./Authentication/LoginPage";
import AuthContainer from "./Auth/index";
import AuthErrorContainer from "./Auth/Error";
import AuthSurveyContainer from "./Auth/Survey";
import PhotoContainer from "./Photo/index";
import VideoPlayerContainer from "./Photo/VideoPlayer";
import ProductContainer from "./Product/index";
import HelpContainer from "./Help/index";
import VerificationContainer from "./Verification/index";
import EventContainer from "./Event";
import EventInputContainer from "./EventInput";
import SettingContainer from "./Setting/index";
import SampleModalSmallContainer from "./Sample/ModalSmallSample";
import SampleModalLargeContainer from "./Sample/ModalLargeSample";
import SampleModalBarcodeContainer from "./Sample/ModalBarcodeSample";
import DetailContainer from "./Detail";
import FacebookRedirectContainer from "./Authentication/Facebook/Redirect";
import LineRedirectContainer from "./Authentication/Line/Redirect";
import WeiboRedirectContainer from "./Authentication/Weibo/Redirect";

// Styles
import style from "../Styles/Style.module.css";
import Spinner from "../Components/Spinner";
import { logClientEvent } from "../Lib/clientEventLog";

// Actions
import { action } from "../Data";

// Const
import * as Const from "../Data/const";

const SESSION_INIT_TIMEOUT_MS = 5000;

class RootView extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: true,
        }

        this.init = this.init.bind(this);
        this.setCountryCode = this.setCountryCode.bind(this);
    }

    componentDidMount() {
        // session 체크 (앱에 저장된 액세스토큰을 가져옴)
        window.addEventListener('getCountryCode', this.setCountryCode)
        this.init();
        Const.checkAppAccessToken();
    }

    componentDidUpdate(prevProps, prevState) {
        try{
            if (prevProps.COUNTRY_CODE != this.props.COUNTRY_CODE) {
                this.props.i18n.changeLanguage(this.props.COUNTRY_CODE);
            }

            if (prevProps.location.pathname !== this.props.location.pathname) {
                Const.checkAppAccessToken();
            }
        } catch (err) {
        }
    }

    componentWillUnmount() {
        window.removeEventListener('getCountryCode', this.setCountryCode)
    }

    async init() {
        try {
            await Const.compareLocalStorageTime();
            try {
                if (window && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosHandler) {
                    window.webkit.messageHandlers.iosHandler.postMessage({functionName: 'getCountryCode'});
                } else {
                    await this.setCountryCode();
                }
            } catch (e) {
                await this.setCountryCode();
            }
            const sessionRequest = this.props.dispatch(action.eSESSION.getSession())
                .then(() => ({ status: 'success' }))
                .catch(error => ({ status: 'error', error }));
            let sessionTimeout;
            const timeoutRequest = new Promise(resolve => {
                sessionTimeout = setTimeout(() => {
                    resolve({ status: 'timeout' });
                }, SESSION_INIT_TIMEOUT_MS);
            });
            const sessionResult = await Promise.race([sessionRequest, timeoutRequest]);
            clearTimeout(sessionTimeout);

            if (sessionResult.status === 'timeout') {
                logClientEvent('root_session_timeout', {
                    severity: 'warn',
                    timeoutMs: SESSION_INIT_TIMEOUT_MS,
                });
                sessionRequest.then(lateResult => {
                    logClientEvent('root_session_late_result', {
                        severity: lateResult.status === 'success' ? 'info' : 'warn',
                        status: lateResult.status,
                    });
                });
            } else if (sessionResult.status === 'error') {
                logClientEvent('root_session_fail', {
                    severity: 'warn',
                    message: sessionResult.error && sessionResult.error.message,
                });
            }

            this.setState({
                isLoading: false
            });
        } catch (e) {
            console.log(e);
            this.setState({
                isLoading: false
            })
        }
    }

    // 이건 브라우저 CountryCode 가져오는 거임
    async setCountryCode(event) {
        try {
            let countryCode;

            if (event) {
                countryCode = event.detail.countryCode;
            } else {
                countryCode = await Const.getCountryCode();
            }

            console.log("Root.jsx :: getCountryCode - ", countryCode)
            this.props.i18n.changeLanguage(countryCode);
            await this.props.dispatch(action.eSESSION.setCountryCode(countryCode));

            console.log(this.props);
/*            const countryCode = await Const.getCountryCode();
            await this.props.dispatch(action.eSESSION.setCountryCode(countryCode));
            const uuid = await Const.getUUID();
            await this.props.dispatch(action.eSESSION.setUUID(uuid));

            const loginData = await this.props.dispatch(action.eSESSION.getSession());*/

        } catch (e) {

        }
    }

    render() {
        const { t } = this.props;
        return (
            <div className={style.body}>
                {this.state.isLoading ? (
                    <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Spinner size={36}/>
                    </div>
                ) : null}
                {/* 스플래시 */}
                {this.state.isLoading ? null :
                    <Route path={"/user"} exact={true} strict={false} component={HomeContainer} />
                }

                {/* 소셜로그인 화면 */}
                {this.state.isLoading ? null :
                    <Route path={"/user/login"} exact={true} strict={false} component={LoginContainer} />
                }

                {/* 인증 화면*/}
                {this.state.isLoading ? null :
                    <Route path={"/user/auth"} exact={true} strict={false} component={AuthContainer} />
                }

                {/* 인증오류 화면*/}
                {this.state.isLoading ? null :
                    <Route
                        path={"/user/auth/error"}
                        exact={false}
                        strict={false}
                        component={AuthErrorContainer}
                    />
                }

                {/* 설문제출완료 화면*/}
                {this.state.isLoading ? null :
                    <Route
                        path={"/user/auth/survey"}
                        exact={false}
                        strict={false}
                        component={AuthSurveyContainer}
                    />
                }
                {/* AR, QR, NFC 인증화면*/}
                <Route path={"/user/photo"} exact={true} strict={false} component={PhotoContainer} />

                {/* AR, QR, NFC 인증화면*/}
                <Route
                    path={"/user/photo/videoPlayer"}
                    exact={false}
                    strict={false}
                    component={VideoPlayerContainer}
                />

                {/* 인증결과 화면*/}
                { this.state.isLoading ? null :
                    <Route path={"/user/product"} exact={false} strict={false} component={ProductContainer} />
                }

                {/* 도움말 화면*/}
                <Route path={"/user/help"} exact={false} strict={false} component={HelpContainer} />

                {/* 인증내역 화면*/}
                {this.state.isLoading ? null :
                    <Route
                        path={"/user/verification"}
                        exact={true}
                        strict={false}
                        component={VerificationContainer}
                    />
                }

                {/* 인증내역 상세 화면*/}
                {
                    this.state.isLoading ? null :
                        <Route
                            path={"/user/verification/detail"}
                            exact={false}
                            strict={false}
                            component={DetailContainer}
                        />
                }
                {/* 이벤트 화면*/}
                {
                    this.state.isLoading ? null :
                        <Route path={"/user/event"} exact={true} strict={false} component={EventContainer} />
                }
                {/* 이벤트 정보입력 화면*/}
                {
                    this.state.isLoading ? null :
                        <Route
                            path={"/user/event/input"}
                            exact={false}
                            strict={false}
                            component={EventInputContainer}
                        />
                }
                {/* 설정 화면*/}
                <Route path={"/user/setting"} exact={false} strict={false} component={SettingContainer} />
                {/* 샘플 작은모달 화면*/}
                <Route
                    path={"/user/sample/modalSmall"}
                    exact={false}
                    strict={false}
                    component={SampleModalSmallContainer}
                />
                {/* 샘플 큰모달 화면*/}
                <Route
                    path={"/user/sample/modalLarge"}
                    exact={false}
                    strict={false}
                    component={SampleModalLargeContainer}
                />

                {/* 샘플 바코드 모달 화면*/}
                <Route
                    path={"/user/sample/modalBarcode"}
                    exact={false}
                    strict={false}
                    component={SampleModalBarcodeContainer}
                />
                {/* 페이스북 리다이렉트 용 */}
                <Route
                    path={"/user/facebook/redirect"}
                    exact={false}
                    strict={false}
                    component={FacebookRedirectContainer}
                />
                {/* 라인 리다이렉트 용 */}
                <Route
                    path={"/user/line/redirect"}
                    exact={false}
                    strict={false}
                    component={LineRedirectContainer}
                />
                {/* 웨이보 리다이렉트 용 */}
                <Route
                    path={"/user/weibo/redirect"}
                    exact={false}
                    strict={false}
                    component={WeiboRedirectContainer}
                />
            </div>
        );
    }
}

export default connect(state => {
    return {
        eSESSION: state.data.eSESSION.eSESSION,
        COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE,
        UUID: state.data.eSESSION.UUID,
    }
})(withRouter(withTranslation()(RootView)))
